module.exports = __webpack_public_path__ + "img/1065092715.f39b71d8.png";